__turbopack_context__.v({
  "container": "R4TKmq_container",
  "contentFadeIn": "R4TKmq_contentFadeIn",
});
